import { primitive } from 'styles/constants/primitives';

const destinationMarkerSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="60" fill="none">
  <path fill="${Styles.color.red}" d="M31 47a24 24 0 1 0-15.3-.5L23.5 60 31 47z"/>
  <path fill="${primitive.$white}" d="M36.9 20.5h-2.2v11.7c0 .5-.3 1-.8 1h-6.6v-9h-6.7v9h-6c-.6 0-1-.3-1-.8v-12h-2.1v-1.6c0-.4.2-.9.5-1l11.6-7h1.2l11.6 7c.3.1.5.6.5 1v1.7z"/>
</svg>
`;

// eslint-disable-next-line import/no-default-export
export default destinationMarkerSvg;
